module.exports = __webpack_public_path__ + "assets/img/purple-arrow-left.3b3c998a.png";